import styled from 'styled-components';
import {desktopMedia} from '../../../../globalVariables/GlobalVariables';
import {alignCenter, dFlex, dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const panel = styled.div`
    width: 100%;
    max-width: none;
    max-height: 90vh;
    ${dFlexColumn}
    background: var(--color-bg-base);
    color: var(--color-text-default);
    border-radius: var(--border-radius-border-radius-2xl) var(--border-radius-border-radius-2xl) 0 0;
    padding: var(--space-lg) var(--space-lg) max(var(--space-lg), env(safe-area-inset-bottom));
    overflow: hidden;

    ${desktopMedia} {
        max-width: 430px;
        border-radius: var(--border-radius-border-radius-xl);
    }
`;

export const handle = styled.div`
    flex: none;
    width: 36px;
    height: 4px;
    border-radius: 999px;
    background: var(--color-text-subtle);
    margin: 0 auto var(--space-md);

    ${desktopMedia} {
        display: none;
    }
`;

export const head = styled.div`
    ${dFlex}
    ${alignCenter}
    margin-bottom: var(--space-lg);
`;

export const title = styled.span`
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-bold);
`;

export const info = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    ${dFlexColumn}
    gap: var(--space-lg);
    margin-bottom: var(--space-lg);
    white-space: pre-line;
`;

export const foot = styled.div`
    flex: none;
    margin-top: var(--space-lg);
`;
